import { Box, SxProps } from '@mui/material';
import MarkdownComponent from 'react-markdown';

interface MarkdownProps {
  sx: SxProps;
  children?: string | null;
}

export const Markdown = ({ sx, children }: MarkdownProps) => {
  return (
    <Box
      sx={{
        ...sx,
        '& a': {
          color: 'secondary.main',
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline',
          },
        },
      }}>
      <MarkdownComponent>{children}</MarkdownComponent>
    </Box>
  );
};
